import styled from 'styled-components'
import Threshold from 'constants/threshold'
import Colors from 'constants/colors'

export const CourseTitle = styled.h2`
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  margin: 39px 0 40px;

  @media (min-width: ${Threshold.phone}) {
    width: 80%;
    font-size: 35px;
  }

  @media (min-width: ${Threshold.tablet}) {
    margin: 0;
  }
`

export const NameSlash = styled.span`
  color: ${Colors.black};
`

export const CourseContainer = styled.main`
  width: 92%;
  margin: 0 auto 33px;
  max-width: 330px;

  @media (min-width: ${Threshold.phone}) {
    max-width: 500px;
    margin: 0 auto 30px;
  }

  @media (min-width: ${Threshold.tablet}) {
    max-width: 1060px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  justify-content: center;
  position: relative;
  margin-top: 62px;

  @media (min-width: ${Threshold.tablet}) {
    flex-direction: row;
    margin: 87px auto 84px;
    align-items: start;
  }
`

export const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  width: 30px;

  cursor: pointer;
  transition-duration: 0.2s;

  @media (min-width: ${Threshold.tablet}) {
    padding-top: 12px;
    margin: 0;
    position: absolute;
    left: 0;
    width: auto;
  }
`

export const BackImg = styled.img`
  &:hover {
    transform: scale(1.1);
  }
  @media (min-width: ${Threshold.tablet}) {
    width: 20px;
    height: 20px;
  }
`

export const ButtonText = styled.span`
  display: none;
  margin-left: 15px;
  font-weight: 500;
  font-size: 14px;
  color: ${Colors.blue};
  transition: all 200ms ease;

  &:hover {
    opacity: 0.3;
  }

  @media (min-width: ${Threshold.tablet}) {
    display: inline-block;
  }
`

export const CloseModalButton = styled.img`
  display: none;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 11;
  cursor: pointer;
  transition-duration: 0.2s;

  &:hover {
    transform: scale(1.2);
  }

  @media (min-width: ${Threshold.tablet}) {
    display: block;
  }
`
